import Modes from '../models/Modes';
import {defineStore} from 'pinia';
import {SecureLocalStorageManager} from "@/core/service/SecureLocalStorageManager";
import config, {CompanyConfig} from "@/core/config/config";

const LOCALSTORAGE_MODE_KEY = 'mode';
const LOCALSTORAGE_SURVEY_COMPLETED_KEY = 'survey_completed';

interface SettingsState {
    mode: Modes;
    subdomain: string;
    surveyCompleted: boolean | null;
    companyConfig: CompanyConfig;
    initialized: boolean,
    modeSet: boolean,
}

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        mode: Modes.User,
        subdomain: '',
        initialized: false,
        companyConfig: {
            logo: null,
        },
        surveyCompleted: null as boolean | null,
        modeSet: false,
    } as SettingsState),
    actions: {
        async setMode() {
            if (this.modeSet)
                return;
            const params = new URLSearchParams(window.location.search);
            if (params.get('mode_operator') === 'on') {
                this.mode = Modes.Operator;
            } else {
                this.mode = Modes.User;
            }
            this.modeSet = true;
            await SecureLocalStorageManager.setValue(LOCALSTORAGE_MODE_KEY, this.mode);
            window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
        },
        async init() {
            setSubdomain(this.$state);
            setCompanyConfig(this.$state);
            this.surveyCompleted = await SecureLocalStorageManager.getValue(LOCALSTORAGE_SURVEY_COMPLETED_KEY) == 'true';
            this.initialized = true;
        },
        async setSurveyCompleted() {
            this.surveyCompleted = true;
            await SecureLocalStorageManager.setValue(LOCALSTORAGE_SURVEY_COMPLETED_KEY, 'true');
        },
    },
});


function setSubdomain(state: SettingsState) {
    const hostParts = window.location.hostname.split('.');
    if (hostParts.length > 0) {
        const domainParts = hostParts[0].split('-');
        state.subdomain = domainParts[0];
    }
}

function setCompanyConfig(state: SettingsState) {
    if (!state.subdomain)
        throw new Error('Subdomain not set');
    if (config[state.subdomain] == null) {
        throw new Error('Config not found');
    }
    state.companyConfig = config[state.subdomain];
}
